<template>
	<div class="scrollable only-y">
	<div :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
		<div class="page-header card-base card-shadow--medium">
			<h2 class="no-m white-text">
                Manage Prefix
            </h2>
		</div>
	</div>
	<el-card>
        <el-row class="mb-20">
            <h3>{{ marketName }}</h3>
        </el-row>
        <el-row>
            <el-col :xl="18" :lg="18" :md="24" :sm="24" :xs="24" justify="end">
                <el-input
                    style="width:250px;"
                    class="mb-10"
                    size="medium"
                    placeholder="Country Name or Prefix Code"
                    clearable
                    v-model="filterSearchPrefix"
                />
                                
                <el-button-group class="mr-10 ml-10">
                    <el-button @click="getPrefixMarket()" type="primary" round size="medium" :loading="btnLoadingSearchPrefix" class="animated fadeInRight" style="background-color: #0047FF;">
                        <i class="el-icon-search"/>
                    </el-button>
                </el-button-group>
            </el-col>
            <el-col :xl="6" :lg="6" :md="24" :sm="24" :xs="24" justify="end">
                <el-button @click="dialogAddPrefix=true" type="primary" size="medium" class="animated fadeInRight">
                    + Add Prefix
                </el-button>
            </el-col>
        </el-row>

        <el-row>
            <el-table style="width: 100%;" class="mt-30 mb-20" :data="marketPrefixData">
                <el-table-column width="150" label="#">
                    <template slot-scope="props">
						<p style="font-weight:bold;">{{ props.$index + 1 }}</p>
                    </template>
                </el-table-column>
                <el-table-column width="200" label="Prefix Code">
                    <template slot-scope="props">
						<p style="font-weight:bold;">{{ props.row.prefix_code }}</p>
                    </template>
                </el-table-column>
                <el-table-column width="200" label="Country Code">
                    <template slot-scope="props">
						<p style="font-weight:bold;">{{ props.row.country_code }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="Country Name" width="300">
                    <template slot-scope="props">
						<p style="font-weight:bold;">{{ props.row.country_name }}</p>
                    </template>
                </el-table-column>
                <el-table-column label="Action" width="200">
                    <template slot-scope="props">
                        <el-button type="danger" size="mini" @click="deleteMarketPrefixArea(props.row.id, props.row.country_name)">
                            <i class="mdi mdi-delete-forever"></i> 
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
	</el-card>
    <!-- modal dialog add prefix -->
    <el-dialog title="Add Prefix Market Area" :visible.sync="dialogAddPrefix" id="html-2-pdfwrapper">
        <el-row>
            <el-card class="mb-5">
                <el-form class="mb-10" label-width="150px" label-position="top">
                    <el-form-item label="Prefix Market Area">
                        <el-select
                            clearable
                            v-model="addPrefix"
                            placeholder="Prefix Market Area"
                            style="width:300px;"
                            class="mb-10"
                            filterable
                            remote
                            reserve-keyword
                            remote-show-suffix
                        >
                            <el-option
                                v-for="(item, idx) in countries"
                                :key="idx"
                                :label="item.countryNameEn"
                                :value="item.countryNameEn"
                                :disabled="isListPrefix(item.countryCode) ? true : false"
                            >
                                <span style="font-size: 12px">{{ item.countryNameEn + ` (+${item.countryCallingCode})` }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div style="text-align:right;">
                    <el-button type="primary" size="medium" class="animated fadeInRight" @click="createPrefixMarket()">
                        Add
                    </el-button>
                    <el-button type="danger" size="medium" class="animated fadeInRight" @click="dialogAddPrefix=false">
                        Cancel
                    </el-button>
                </div>
            </el-card>
        </el-row>
    </el-dialog>
	<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
		DAM Corp.
	</el-card>
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
import CountryFlag from 'vue-country-flag'
const _ = require('lodash')
const moment = require('moment')
const countryCodes = require('country-codes-list')

export default {
    name: 'bussiness_market_prefix',
	data () {
		return {
            loadingTable: false,
			loadingReportTable: false,
            dialogAddPrefix: false,
            marketPrefixData: [],
            pagination: {
                total: 0,
                page: 1
            },
            addPrefix: '',
            marketName: `Manage Prefix Market ${this.$route.params.market_name}`,
            countries: [],
            filterSearchPrefix: '',
            btnLoadingSearchPrefix: false
		}
	},
	methods: {
        log(data) {
            console.log(data, " <<data");
        },
        isListPrefix(countryCode) {
            return _.find(this.marketPrefixData, (v) => {
                return v.country_code === countryCode
            })
        },
        async getPrefixMarket(page){
            this.btnLoadingSearchPrefix=true;
            var params = {
                page: page,
                master_market_area_id: this.$route.params.master_market_area,
                q: this.filterSearchPrefix
            }

            await api({
                method: 'get',
                url:config.baseApi+'master-prefix',
                params
            }).then(result => {
                var data =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.rows
                        ? result.data.data.rows
                        : [];
                var status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                var total =
                    result &&
                    result.data &&
                    result.data.data &&
                    result.data.data.count
                        ? result.data.data.count
                        : 0;
                if(status === 200) {
                    this.marketPrefixData = data;
                    this.pagination.total = total;
                }
                this.btnLoadingSearchPrefix=false;
            }).catch(error => {
                console.error("Failed : " + error);
            })
	    },
        async deleteMarketPrefixArea(id, name){
            await this.$swal({
                title: `Are you sure want to delete this prefix market area ${name}?`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
               
                api({
                    method: 'delete',
                    url: config.baseApi+`master-prefix/${id}`,
                }).then(result => {
                    const status =
                        result &&
                        result.data &&
                        result.data.ec
                            ? result.data.ec
                            : null;

                    if(status === 200) {
                        this.$swal(this.$t('success'), this.$t('success'), "success")
                        this.getPrefixMarket(1);
                    }
                }).catch(error => {
                    console.error("Failed : " + error);
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                })
            }).catch(err => {
                console.log(err);
            })
        },
        async createPrefixMarket(){
            let filterData = {};
            this.countries.map(item => {
                if(item.countryNameEn === this.addPrefix) {
                    filterData = item;
                }
            })

            var data = {
                master_market_area_id: this.$route.params.master_market_area,
                prefix_code: `+${filterData.countryCallingCode}`,
                country_code: filterData.countryCode,
                country_name: filterData.countryNameEn
            };

            await api({
                method: 'post',
                url:config.baseApi+'master-prefix',
                data: data
            }).then(result => {
                const status =
                    result &&
                    result.data &&
                    result.data.ec
                        ? result.data.ec
                        : null;
                const message =
                    result &&
                    result.data &&
                    result.data.message
                        ? result.data.message
                        : '';
                if(status === 200) {
                    this.$swal(this.$t('success'), this.$t('success'), "success");
                    this.dialogAddPrefix = false;
                    this.getPrefixMarket(1);
                    this.addPrefix = '';
                } else {
                    this.$swal(message, '', "error");
                }
            }).catch(error => {
                console.error("Failed : " + error);
            })
	    }
	},
	async mounted(){
        await this.getPrefixMarket(1);
	},
    created(){
        this.countries = countryCodes.all();
    }
}
</script>
<style>
.swal2-container {
	z-index: 10000 !important;
}
</style>
<style lang="scss">
@import '../../assets/scss/_variables';
.chart {
     width: 100%;
     height: 400px;
 }
.page-invoice {
	.toolbar {
		max-width: 794px;
		margin: 0 auto;
		text-align: right;
		margin-bottom: 20px;
	}

	.invoice {
		background: white;
		width: 100%;
		max-width: 794px;
		min-height: 1123px;
		margin: 0 auto;
		padding: 2em;
		box-sizing: border-box;
		box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

		hr {
			border: 1px solid rgba(0, 0, 0, 0.05);
		}

		.invoice-top {
			overflow: hidden;
			margin-bottom: 30px;

			.logo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: rgba(0, 0, 0, 0.07);
				text-align: center;

				img {
					height: 80%;
					margin-top: 10%;
				}
			}
			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}
			.title {
				float: right;

				& > * {
					margin: 0;
				}

				p {
					text-align: right;
				}
			}
		}

		.invoice-middle {
			overflow: hidden;
			margin-top: 30px;
			margin-bottom: 30px;

			.clientlogo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: grey;

				img {
					width: 100%;
				}
			}

			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}

			.project {
				margin-left: 52%;

				& > * {
					margin: 0;
				}
			}
		}

		.invoice-bottom {
			table {
				width: 100%;
				border-collapse: collapse;

				th {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					opacity: .7;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				td {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					border-bottom: 1px solid #EEE;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				tfoot td {
					border: none;
					padding-top: 5px;
				}
			}
		}

		h1 { font-size: 1.5em; color: #222; }
		h2 { font-size: .9em; }
		h3 { font-size: 1.2em; font-weight: 300; line-height: 2em; }
		p  { font-size: .7em; color: #666; line-height: 1.2em; }
	}

}


@media screen and (max-width: 768px) {
	.page-invoice {
		.invoice {
			.invoice-middle {
				.project {
					display: block;
					width: 100%;
					clear: both;
					padding: 10px 0;
					margin: 0;
				}
			}
			.invoice-bottom {
				table {
					th {
						padding: 5px;
					}

					td {
						padding: 5px;
					}
				}
			}
		}
	}
}

@media print{
	.layout-container .container .footer ,
	.layout-container .container .header ,
	.layout-container .container .horizontal-nav ,
	.layout-container .footer ,
	.layout-container .layout-picker ,
	.layout-container .vertical-nav ,
	.layout-container .header {
		display:none;
	}

	.page-invoice {
		.toolbar {
			display: none;
		}

		.invoice {
			box-shadow: none;
			max-width: 100%;
			padding: 0;
		}
	}
}
</style>
<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.fl-r {
	float:right;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
